import { Capacitor } from "@capacitor/core";

import { MARKETING_DEMO_DEVICE_ID } from "./constants";

export function isMarketingDemoEligible(
  deviceId: string | null | undefined,
  platform: string = Capacitor.getPlatform(),
): boolean {
  if (!deviceId?.trim()) return false;
  if (platform !== "ios") return false;
  return deviceId.trim() === MARKETING_DEMO_DEVICE_ID;
}
